import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs/internal/Subject';

@Component({
  selector: 'app-manager-approver-popup',
  templateUrl: './manager-approver-popup.component.html',
  styleUrls: ['./manager-approver-popup.component.scss']
})
export class ManagerApproverPopupComponent implements OnInit {

  public title !: any;
  public vendorName!:any;
  public isRFQSENT!:any;
  public rankCheck!:any;
  public rank!:any;
  public onClose = new Subject<any>();

  constructor(public bsModalRef:BsModalRef,private _router : Router,) { }

  ngOnInit(): void {
  }

  public closeModel(value:boolean=false){
    if(!this.isRFQSENT && !this.rankCheck)
      this._router.navigate([`/dashboard`])
    this.onClose.next(value)
    this.bsModalRef.hide()
  }

}
